export enum ReasonType
{
    UserReport = 1,
    MessageReport = 2
}